import React from "react";
import { useTranslation } from "react-i18next";
import { NoDataPlaceholder } from "../../../../components/common";

type SurveyPageContentStateProps = {
  hasSurveys: boolean;
  search: string;
};

const SurveyPageContentState: React.FC<SurveyPageContentStateProps> = ({
  hasSurveys,
  search,
}) => {
  const { t } = useTranslation();

  if (!hasSurveys) {
    return (
      <NoDataPlaceholder
        variant="surveys"
        title={search ? t("survey.no_surveys_found") : t("survey.no_surveys_available")}
      />
    );
  }

  return null;
};

export default SurveyPageContentState;
